
<h2 mat-dialog-title>Choix du bénéficiaire</h2>
<div class="header-PS">
    <div class="line-header">
        <label class="label-PS">Immat : <strong>{{ DonneesCV.NIR}}{{ DonneesCV.cleNIR}}</strong></label> 
        <label class="label-PS">N° de serie carte : <strong>{{ DonneesCV.numeroSerie}}</strong></label> 
    </div>
    <div class="line-header">
        <label class="lbl-secondary">Régime : {{DonneesCV.codeRegime}} - {{DonneesCV.libelleRegime}}</label>
        <label class="lbl-secondary">Caisse : {{DonneesCV.caisseGestionnaire}} - {{DonneesCV.libelleCaisse}}</label>
        <label class="lbl-secondary">Centre : {{DonneesCV.centreGestionnaire}} - {{DonneesCV.libelleGestion}}</label>
    </div>
</div>
<hr>
<mat-dialog-content>
    <mat-list>
        <mat-list-item
          *ngFor="let beneficiaire of DonneesCV.lstDonneesBeneficiaire"
          (click)="selectBenef(beneficiaire)"
          class="selectable-item">
        
            <div mat-line>{{ beneficiaire.nomUsuel}} {{ beneficiaire.prenom}}</div>
            <div mat-line class="secondary">{{ afficheInfos(beneficiaire) }}</div>
        </mat-list-item>
    </mat-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button (click)="close()">Annuler</button>
</mat-dialog-actions>